import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRanking", "isRankingItem"];

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { B100, N20, N50A, N60A } from '@atlaskit/theme/colors';
import { TableBodyRow } from '../table-row';
var rankingStyles = css({
  display: 'block'
});
var elevationStyle = "var(--ds-shadow-overlay, ".concat("0 20px 32px -8px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")");
/**
 * TODO: Pass the props here to get particular theme for the table
 * Skipping it for now as it may impact migration as util-shared-styles does not support this feature
 */

var rankingItemStyles = css({
  backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
  borderRadius: '2px',
  boxShadow: elevationStyle
});
var draggableStyles = css({
  outlineWidth: '2px',
  '&:focus': {
    outlineColor: "var(--ds-border-focused, ".concat(B100, ")"),
    outlineStyle: 'solid'
  }
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc

export var RankableTableBodyRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isRanking = _ref.isRanking,
      isRankingItem = _ref.isRankingItem,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(TableBodyRow, _extends({
    css: [isRanking && rankingStyles, isRankingItem && rankingItemStyles, draggableStyles],
    ref: ref
  }, props));
});